export default function Footer() {
    return (
        <footer className="mpa-footer">
            Copyright &copy; {new Date().getFullYear()}{' '}
            <a href="/">MPA — My Personal Assistant</a>
        </footer>
    );
}
